import {
    AfterContentInit,
    Component, DoCheck,
    EventEmitter,
    Input,
    IterableDiffers, KeyValueDiffers,
    OnChanges,
    Output,
    SimpleChanges,
} from "@angular/core";
import * as _ from "lodash";
import {DataMappingHelpers} from "../../../../../../../../models/data-mapping-helpers";
import {MuleMapping} from "../../../../../../../../models/mule-mapping";
import { BaseError } from "../../../../../../base-error";
import {ToastrService} from "ngx-toastr";

@Component({
    selector: "field-item",
    templateUrl: "./field-item.component.html",
})
export class FieldItemComponent extends BaseError implements OnChanges, DoCheck, AfterContentInit {

    @Input() public isRoot: boolean = false;
    @Input() public fieldItem: any;
    @Input() public id: string;
    @Input() public hidden: boolean;
    @Input() public type: string;
    @Input() public isLtr: boolean;
    @Input() public dragSrc: any = { el: null };
    @Input() public lines: any[] = [];
    @Input() public hideFields: any;
    @Input() public rightPrefix: string;

    @Output("showHideField") public showHideField: EventEmitter<any> = new EventEmitter();
    @Output("deleteSelection") public deleteSelection: EventEmitter<any> = new EventEmitter();
    @Output("handleEndPointSelection") public handleEndPointSelection: EventEmitter<any> = new EventEmitter();
    @Output("handleStartPointSelection") public handleStartPointSelection: EventEmitter<any> = new EventEmitter();
    @Output("addDataTransformation") public addDataTransformation: EventEmitter<any> = new EventEmitter();

    public linesDiffer: any = {};
    public oldLines: any[] = [];
    public hideFieldsDiffer: any = {};

    public oldDragSrcEl: any;
    public oldIsopen: any;

    public firstTime: boolean = true;

    public translatableFields: string[] = ["created", "modified", "mapping_status", "mapping_message", "mapping_error"];

    constructor(private iterableDiffers: IterableDiffers, public toastr: ToastrService, private keyValueDiffers: KeyValueDiffers) {
        super(toastr);
    }

    public ngOnChanges(changes: SimpleChanges) {
        if (changes.hidden) {
            this.changeMetaAfterNgOnChange();
        }
        if (!changes.lines) {
            this.oldLines = [...this.lines];
        }
    }
    public ngDoCheck() {

        // check if any new lines present or existing ones deleted
        if (!_.isEqual(this.oldLines, this.lines) || this.lines.length && this.firstTime) {
            this.firstTime = false;
            this.oldLines = [...this.lines];
            this.changeMetaAfterLinesChange();
        }

        // check if hideFields changed
        // to put back if wanted
        // const changeshiding = !_.isEmpty(this.hideFieldsDiffer) && this.hideFieldsDiffer.diff(this.hideFields);
        // if (changeshiding) {
            // const changedKeys = new Set();
            // changeshiding.forEachChangedItem((change) => changedKeys.add(change.key));
            // if (changedKeys.has(this.fieldItem.field.name ? this.fieldItem.field.name : this.fieldItem.field.fieldName)) { this.changeMetaAfterNgOnChange(); }
        // }

        // check if dragSrc is changed
        if (!_.isEqual(this.oldDragSrcEl, this.dragSrc.el)) {
            this.changeMetaAfterDragSrcChange();
            this.oldDragSrcEl = this.dragSrc.el;
        }

        // check if isopen is changed
        if (this.oldIsopen === this.fieldItem.isopen) {
            this.changeMetaAfterIsopenChange();
            this.oldIsopen = this.fieldItem.isopen;
        }
    }
    public ngAfterContentInit() {
        this.initStaticMeta();
    }

    public changeMetaAfterNgOnChange() {
        if (!this.fieldItem.meta) { this.fieldItem.meta = {}; }
        if (!this.fieldItem.meta.rowClasses) { this.fieldItem.meta.rowClasses = {}; }
        // if (!this.fieldItem.meta.childEyeClasses) { this.fieldItem.meta.childEyeClasses = {}; }
        this.fieldItem.meta.rowClasses.hidden = this.hidden;
        // this.fieldItem.meta.childEyeClasses["fa-eye-slash"] = this.hideFields[this.fieldItem.field.name ? this.fieldItem.field.name : this.fieldItem.field.fieldName];
        // this.fieldItem.meta.childEyeClasses["fa-eye"] = !this.hideFields[this.fieldItem.field.name ? this.fieldItem.field.name : this.fieldItem.field.fieldName];
    }

    public changeMetaAfterLinesChange() {
        const hasRelationship = this.haveRelationship(this.fieldItem.field);
        const lineRelationship = this.getRelationship(this.fieldItem.field);
        const linesRelationship = this.getRelationships(this.fieldItem.field);
        // console.log("--- fieldItem", this.fieldItem, this.lines, linesRelationship);
        if (lineRelationship && linesRelationship?.length < 2) {
            if (lineRelationship?.targetFieldProperties?.hasOwnProperty("sortByFields") && lineRelationship?.targetFieldProperties?.sortByFields.length) {
                lineRelationship.targetFieldProperties.sortByFields = [];
            }
        }
        if (!this.fieldItem.meta) { this.fieldItem.meta = {}; }
        if (!this.fieldItem.meta.rowClasses) { this.fieldItem.meta.rowClasses = {}; }
        if (!this.fieldItem.meta.ifs) { this.fieldItem.meta.ifs = {}; }
        this.fieldItem.meta.rowClasses.connected = hasRelationship;
        this.fieldItem.meta.ifs.deleteLine = this.isLtr && hasRelationship;
        this.fieldItem.meta.ifs.line = lineRelationship;
        if (this.fieldItem.meta.ifs.line && (this.fieldItem?.field?.id?.endsWith("_key") || this.fieldItem?.field?.id?.endsWith("_value"))) {
            this.fieldItem.meta.ifs.notfullCatalogMapped = !this.isKeyAndValueMapped(this.fieldItem?.field?.id?.replace(/_key$/, "").replace(/_value$/, ""));
        }
        this.fieldItem.meta.ifs.lines = linesRelationship;
        this.fieldItem.meta.readableTransformation = null;
        if (this.fieldItem.meta.ifs.line && this.fieldItem.meta.ifs.lines.length < 2 && (this.fieldItem.meta.ifs.line.targetFieldProperties || (this.checkDeterminant(this.fieldItem.meta.ifs.line)))) {
            this.fieldItem.meta.hasTransformation = true;
            if (this.fieldItem.meta.ifs.line.targetFieldProperties?.hasOwnProperty("sortByFields") && this.fieldItem.meta.ifs.line.targetFieldProperties?.sortByFields.length) {
                this.fieldItem.meta.readableTransformation = `${this.fieldItem.meta.readableTransformation ? this.fieldItem.meta.readableTransformation + "\n" : ""}${this.formatSortByField(this.fieldItem.meta.ifs.line.targetFieldProperties?.sortByFields)}`;
            } else if (this.fieldItem.meta.ifs.line.targetFieldProperties?.hasOwnProperty("inputTransformations") && this.fieldItem.meta.ifs.line.targetFieldProperties?.inputTransformations.length) {
                this.fieldItem.meta.readableTransformation = "Transform input\n";
            } else {
                this.fieldItem.meta.hasTransformation = (this.fieldItem.meta.ifs.line.targetFieldProperties?.fieldOperator && this.fieldItem.meta.ifs.line.targetFieldProperties?.fieldOperator !== "exact")
                  || this.fieldItem.meta.ifs.line.targetFieldProperties?.useAsExactSearch
                  || this.fieldItem.meta.ifs.line.targetFieldProperties?.useAsFullTextSearch
                  || this.fieldItem.meta.ifs.line.targetFieldProperties?.useAsStartsWith
                  || (this.checkDeterminant(this.fieldItem.meta.ifs.line));
                if (this.fieldItem.meta.ifs.line.targetFieldProperties?.useAsExactSearch) { this.fieldItem.meta.readableTransformation = `${this.fieldItem.meta.readableTransformation ? this.fieldItem.meta.readableTransformation + "\n" : ""}Exact match`; }
                if (this.fieldItem.meta.ifs.line.targetFieldProperties?.useAsFullTextSearch) { this.fieldItem.meta.readableTransformation = `${this.fieldItem.meta.readableTransformation ? this.fieldItem.meta.readableTransformation + "\n" : ""}Contains`; }
                if (this.fieldItem.meta.ifs.line.targetFieldProperties?.useAsStartsWith) { this.fieldItem.meta.readableTransformation = `${this.fieldItem.meta.readableTransformation ? this.fieldItem.meta.readableTransformation + "\n" : ""}Starts with`; }
                if (this.fieldItem.meta.ifs.line.targetFieldProperties?.fieldOperator) { this.fieldItem.meta.readableTransformation = `${this.fieldItem.meta.readableTransformation ? this.fieldItem.meta.readableTransformation + "\n" : ""}${this.formatfieldOperatorLabel(this.fieldItem.meta.ifs.line.targetFieldProperties?.fieldOperator)}`; }
                if (this.checkDeterminant(this.fieldItem.meta.ifs.line)) {
                    this.fieldItem.meta.readableTransformation = `${this.fieldItem.meta.readableTransformation ? this.fieldItem.meta.readableTransformation + "\n" : ""}Determinants`;
                }
            }
        } else {
            if (this.fieldItem.meta.ifs.lines.length > 1) {
                this.fieldItem.meta.hasTransformation = false;
                this.fieldItem.meta.ifs.lines.forEach((l) => {
                    if (this.checkLineTransformations(l)) {
                        this.fieldItem.meta.hasTransformation = true;
                    }
                });
            } else {
                this.fieldItem.meta.hasTransformation = false;
            }
        }

        this.fieldItem.meta.transformationClasses = this.fieldItem.meta.hasTransformation ? "has-value" : "";
    }

    public isKeyAndValueMapped(baseField) {
        const lines = this.lines.filter((l) => l.input.id === `${baseField}_key` || l.input.id === `${baseField}_value`);
        return lines.length === 2;
    }

    public checkLineTransformations(line) {
        return this.checkTargetFieldProperties(line.targetFieldProperties) || this.checkDeterminant(line);
    }

    public checkTargetFieldProperties(targetFieldProperties) {
        return targetFieldProperties?.distinctByFields?.length ||
            targetFieldProperties?.groupByFields?.length ||
            targetFieldProperties?.inputTransformations?.length ||
            targetFieldProperties?.useAsExactSearch ||
            targetFieldProperties?.useAsFullTextSearch ||
            targetFieldProperties?.sortByFields?.length ||
            targetFieldProperties?.useAsStartsWith ||
            (targetFieldProperties?.fieldOperator?.length && targetFieldProperties?.fieldOperator !== "exact");
    }

    private checkDeterminant(field) {
        if (field.jsonDeterminant && JSON.stringify(field.jsonDeterminant) !== "[{\"type\":\"OR\",\"items\":[]}]") {
            return true;
        }
        if (field.jsonDeterminant?.jsonString && JSON.stringify(field.jsonDeterminant.jsonString) !== "[{\"type\":\"OR\",\"items\":[]}]") {
            return true;
        }
        if (field.jsonDeterminantFilter && JSON.stringify(field.jsonDeterminantFilter) !== "[{\"type\":\"OR\",\"items\":[]}]") {
            return true;
        }
        if (field.jsonDeterminantFilter?.jsonString && JSON.stringify(field.jsonDeterminantFilter?.jsonString) !== "[{\"type\":\"OR\",\"items\":[]}]") {
            return true;
        }
    }

    public formatfieldOperatorLabel(value) {
        let label = "";
        switch (value) {
            case "exact":
                label = "Equals value";
                break;
            case "iexact":
                label = "Equals value without case-sensitive";
                break;
            case "exact~":
                label = "Not equals value";
                break;
            case "iexact~":
                label = "Not Equals value without case-sensitive";
                break;
            case "nexact":
              label = "Equals normalized value";
              break;
            case "niexact":
              label = "Equals normalized value without case-sensitive";
              break;
            case "nexact~":
              label = "Not equals normalized value";
              break;
            case "niexact~":
              label = "Not Equals normalized value without case-sensitive";
              break;
            case "contains":
                label = "Contains value";
                break;
            case "icontains":
                label = "Contains value without case-sensitive";
                break;
            case "in":
                label = "Can be found in";
                break;
            case "defers":
                label = "Not contains value";
                break;
            case "idefers":
                label = "Not contains value without case-sensitive";
                break;
            case "regex":
                label = "Regex expression";
                break;
            case "iregex":
                label = "Regex expression without case-sensitive";
                break;
            case "isnull":
                label = "Nullable";
                break;
            case "isnull~":
                label = "Not nullable";
                break;
            case "lt":
                label = "less than value";
                break;
            case "lte":
                label = "less or equal than value";
                break;
            case "gt":
                label = "greater than value";
                break;
            case "gte":
                label = "greater or equal than value";
                break;
            case "startswith":
                label = "Starts with";
                break;
            case "similarity":
                label = "Similarity";
                break;
            case "nsimilarity":
                label = "Similarity and normalization";
                break;
            case "fuzzy":
                label = "Fuzzy";
                break;
            case "fuzzy_1":
                label = "Fuzzy with precision class 1";
                break;
            case "fuzzy_2":
                label = "Fuzzy with precision class 2";
                break;
            case "fuzzy_3":
                label = "Fuzzy with precision class 3";
                break;
            case "fuzzy_4":
                label = "Fuzzy with precision class 4";
                break;
            case "fuzzy_5":
                label = "Fuzzy with precision class 5";
                break;
            case "fuzzy_6":
                label = "Fuzzy with precision class 6";
                break;
            case "fuzzy_7":
                label = "Fuzzy with precision class 7";
                break;
            case "fuzzy_8":
                label = "Fuzzy with precision class 8";
                break;
        }
        return label;
    }

    private formatSortByField(props) {
        let str = "";
        props.forEach((i) => {
            const existline = this.lines.filter((line) => line.field.fieldKey === i.id);
            let lbl = "";
            if (existline && existline[0] && existline[0].field) {
                 lbl = existline[0].field.label;
            }
            if (i.transformation === "uppercase") { lbl = lbl.toUpperCase(); }
            if (i.transformation === "lowercase") { lbl = lbl.toLowerCase(); }
            str += " " + i.separator + " " + lbl + " ";
        });
        return str;
    }

    public changeMetaAfterDragSrcChange() {
        if (!this.fieldItem.meta) { this.fieldItem.meta = {}; }
        if (!this.fieldItem.meta.rowClasses) { this.fieldItem.meta.rowClasses = {}; }
        this.fieldItem.meta.rowClasses.dragging = (!this.isLtr && _.isEqual(this.dragSrc.el, this.fieldItem.field));
    }

    public changeMetaAfterIsopenChange() {
        if (!this.fieldItem.meta) { this.fieldItem.meta = {}; }
        if (!this.fieldItem.meta.rowClasses) { this.fieldItem.meta.rowClasses = {}; }
        this.fieldItem.meta.rowClasses["parent-opened"] = (!this.isRoot && this.fieldItem.isopen);
    }

    private stripHtml(value: string): string {
        if (!value) { return value; }
        return value.replace(/<[^>]*>/g, "");
    }

    public initStaticMeta() {
        const customRowClass = this.rowClass(this.fieldItem);
        const customColumnClass = this.columnClass(this.fieldItem);
        const customFieldClass = this.getFieldClass(this.fieldItem.field.type);
        // const customChildBadgeClass = this.childBadgeClass(this.fieldItem);

        if (!this.fieldItem.meta) { this.fieldItem.meta = {}; }
        if (!this.fieldItem.meta.rowClasses) { this.fieldItem.meta.rowClasses = {}; }
        if (!this.fieldItem.meta.columnClasses) { this.fieldItem.meta.columnClasses = {}; }
        if (!this.fieldItem.meta.fieldClasses) { this.fieldItem.meta.fieldClasses = {}; }
        // if (!this.fieldItem.meta.childBadgeClasses) { this.fieldItem.meta.childBadgeClasses = {}; }
        if (!this.fieldItem.meta.texts) { this.fieldItem.meta.texts = {}; }
        this.fieldItem.meta.rowClasses["parent-opened"] = (!this.isRoot && this.fieldItem.isopen);
        this.fieldItem.meta.rowClasses["i-b"] = this.type === "input";
        this.fieldItem.meta.rowClasses["o-b"] = this.type !== "input";
        this.fieldItem.meta.rowClasses[customRowClass] = true;
        this.fieldItem.meta.columnClasses[customColumnClass] = true;
        this.fieldItem.meta.fieldClasses[customFieldClass] = true;
        // this.fieldItem.meta.childBadgeClasses[customChildBadgeClass] = true;
        const workingLabel = this.stripHtml(this.fieldItem.workingLabel);
        this.fieldItem.meta.texts.name =  (workingLabel && workingLabel.length) ? `<span class="working-text">${workingLabel}<span class="working-text-tooltip">${this.childName(this.fieldItem)}</span></span>` : this.childName(this.fieldItem);
        this.fieldItem.meta.id = DataMappingHelpers.getSanitizeID((this.fieldItem.field.id || this.fieldItem.field.fieldKey), this.rightPrefix);
    }

    public haveRelationship(input): boolean {
        return DataMappingHelpers.haveRelationship(this.lines, input);
    }

    public getRelationship(input): any {
        return DataMappingHelpers.getLine(this.lines, input);
    }

    public getRelationships(input): any {
        return DataMappingHelpers.getLines(this.lines, input);
    }

    public getFieldClass(type): string {
        return DataMappingHelpers.getFieldClass(type);
    }

    public getSanitizeGroupName(input_name, prefix): string {
        return prefix + DataMappingHelpers.getSanitizeGroupName(input_name);
    }

    public fieldItemOnClick(item: any): void {
        this.changeMetaAfterLinesChange();
        if (this.isLtr) { return this.handleEndPointSelection.emit({
            input: item.field, selector: DataMappingHelpers.getSanitizeID(item.field.id || item.field.fieldKey), type: "input"});
        }
        return this.handleStartPointSelection.emit(item.field);
    }

    public deleteSelectionChild(id: any): void {
        this.changeMetaAfterLinesChange();
        return this.deleteSelection.emit(id);
    }

    public rowClass(fieldItem): string {
        if (this.isRoot) {
            return "";
        }
        const rowClass = " ";
        return rowClass + this.getSanitizeGroupName(fieldItem.field ? (fieldItem.field.name || fieldItem.field.fieldName || fieldItem.field.label || fieldItem.field.fieldKey) : (fieldItem.name ? fieldItem.name : fieldItem.fieldName), this.type === "input" ? "i-b-" : "o-b-");
    }

    public columnClass(fieldItem): string {
        if (this.isRoot) {
            return;
        }
        if (this.type === "input") {
            return "inputs-block-cell inputs-block-cell-i " + this.getSanitizeGroupName(fieldItem.field ? (fieldItem.field.name || fieldItem.field.fieldName || fieldItem.field.label || fieldItem.field.fieldKey) : (fieldItem.name ? fieldItem.name : fieldItem.fieldName), "inputs-block-");
        }
        return "inputs-block-cell inputs-block-cell-o " + this.getSanitizeGroupName(fieldItem.field ? (fieldItem.field.name || fieldItem.field.fieldName || fieldItem.field.label || fieldItem.field.fieldKey) : (fieldItem.name ? fieldItem.name : fieldItem.fieldName), "outputs-block-");
    }

    public childName(fieldItem): string {
        const rawName = fieldItem.field ? (fieldItem.field.name || fieldItem.field.fieldName || fieldItem.field.label || fieldItem.field.fieldKey) : (fieldItem.name ? fieldItem.name : fieldItem.fieldName);
        const cleanName = this.stripHtml(rawName);
        if (this.isRoot) {
            return DataMappingHelpers.formatName(cleanName);
        }
        return FieldItemComponent.getFieldName(cleanName);
    }

    public static getFieldName(input_name = ""): any {
      input_name.replace(/_child_/, ".").replace(/__exact$/, "");
      let parts = [];
      if (input_name.endsWith("_at")) {
            input_name = input_name.substring(0, (input_name.length - 3));
        }
      if (input_name.indexOf("content_child_") !== -1) {
            parts = input_name.split("content_child_");
            return parts.length > 1 ? FieldItemComponent.getFieldSplitName(parts[1]) : parts;
        }
      if (input_name.indexOf("content_collection_") !== -1) {
            parts = input_name.split("content_collection_");
            return parts.length > 1 ? FieldItemComponent.getFieldSplitName(parts[1]) : parts;
        }
      if (input_name.indexOf("collection_child_") !== -1) {
            parts = input_name.split("collection_child_");
            return parts.length > 1 ? FieldItemComponent.getFieldSplitName(parts[1]) : parts;
        }
      if (input_name.indexOf("collection_content") !== -1) {
            parts = input_name.split("collection_content");
            return parts.length > 1 ? FieldItemComponent.getFieldSplitName(parts[1]) : parts;
        }
      if ((input_name.split(".").length > 2)) {
            parts = input_name.split(".");
            return parts[parts.length - 1];
        }
      return FieldItemComponent.getFieldSplitName(input_name);
    }

    public static getFieldSplitName(input_name): string {
        if (input_name.includes("{{") && input_name.includes("}}")) {
            return input_name;
        } else {
            const parts = input_name.split(".");
            return parts.length > 1 ? parts[1] : input_name;
        }
    }

    public childBadgeClass(fieldItem): string {
        if (this.isRoot && this.type === "input" && fieldItem.field.required) { return "field-required"; }
        if (fieldItem.field.required) { return "field-required"; }
        return "";
    }

    public onAddDataTransformation(fieldItem): void {
        this.changeMetaAfterLinesChange();
        this.addDataTransformation.emit(fieldItem);
    }
}
